import { render, staticRenderFns } from "./rightFileTable.vue?vue&type=template&id=049101c6&scoped=true"
import script from "./rightFileTable.vue?vue&type=script&lang=js"
export * from "./rightFileTable.vue?vue&type=script&lang=js"
import style0 from "./rightFileTable.vue?vue&type=style&index=0&id=049101c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049101c6",
  null
  
)

export default component.exports